import { Box, Tab, Tabs } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildSharedPath } from "../../hooks/useSharedFilters";

const ModuleTabs = ({ tabs = [] }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const current = [...tabs].sort((a, b) => b.to.length - a.to.length).find((tab) => location.pathname === tab.to || location.pathname.startsWith(`${tab.to}/`))?.to || tabs[0]?.to || false;

  return (
    <Box className="module-tabs" sx={{ mb: 3, minWidth: 0, width: "fit-content", maxWidth: "100%", p: 0.5, border: "1px solid", borderColor: "divider", borderRadius: 1, background: (theme) => theme.custom?.surface?.overlay || theme.palette.background.paper, boxShadow: (theme) => theme.custom?.glass?.boxShadow || "none" }}>
      <Tabs value={current} variant="scrollable" allowScrollButtonsMobile>
        {tabs.map((tab) => (
          <Tab
            key={tab.to}
            value={tab.to}
            label={tab.labelKey ? t(tab.labelKey, tab.label) : tab.label}
            icon={tab.icon}
            iconPosition="start"
            component={Link}
            to={buildSharedPath(tab.to, location.search)}
            sx={{ minHeight: 42 }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ModuleTabs;
